// import { Message } from 'element-ui'
import 'nprogress/nprogress.css' // Progress 进度条样式
import NProgress from 'nprogress' // Progress 进度条

import router from '@/router/index'
// import { getStatus } from 'sky-engine/utils/auth' // 验权

import store from '@/store'

import { getMenu, isSoftManager, getPath } from '@/utils/permission'
const whiteList = ['/help', '/help/index', '/help/search', '/help/content'] // 不重定向白名单
console.log('开启权限控制')
router.beforeEach((to, from, next) => {
  NProgress.start() // 开启Progress
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next()
    NProgress.done()
  } else {
    if (store.getters.isLogined) {
      // 判断用户是否登录
      console.log('用户登录状态', store.getters.isLogined)
      handleRouteSwithWithLogined(from, to, next)
    } else {
      if (to.path === '/login') {
        next()
      } else {
        next('/login')
      }
      // 否则全部重定向到登录页
      NProgress.done() // router在hash模式下 手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
})

router.afterEach(to => {
  NProgress.done()
})

function handleRouteSwithWithLogined(from, to, next) {
  const isSoftManage = isSoftManager(store.getters.userInfo.permissions)
  if (!store.getters.addRouters || store.getters.addRouters.length === 0) {
    let menu = getMenu(isSoftManage)
    store.dispatch('GenerateRoutes', { menu }).then(() => {
      // 生成可访问的路由表
      router.options.routes = router.options.routes.concat(store.getters.addRouters)
      router.addRoutes(store.getters.addRouters)

      if (to.path === '/login' || to.path === '/') {
        const path = getPath(isSoftManage)
        next(path)
      } else {
        next({ ...to, replace: true })
      }
    })
  } else {
    if (to.path === '/login' || to.path === '/') {
      const path = getPath(isSoftManage)
      next(path)
    } else {
      next() // hack方法 确保addRoutes已完成 ,replace: true so the navigation will not leave a
    }
  }
}
